module.exports = __webpack_public_path__ + "img/money-down.1ddb48ac.png";